import { useEffect } from "react";

export default function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const words = document.querySelectorAll(".highlight-word");
    const metrics = document.querySelectorAll(".metric");

    const revealOnScroll = () => {
      elements.forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 100) {
          el.classList.add("animate-fadeUp");
        }
      });

      words.forEach((word) => {
        const top = word.getBoundingClientRect().top;
        if (top < window.innerHeight - 80) {
          word.classList.add("visible");
        }
      });

      metrics.forEach((m) => {
        const top = m.getBoundingClientRect().top;
        if (top < window.innerHeight - 80) {
          m.classList.add("visible");
        }
      });
    };

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);
}
